/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { isArrayNotEmpty } from "utils/empty-exists";

const NumberFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};
    
    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { style } = settings || {};
                    const number = value.toString();
                    return (
                        <Fragment key={index}>
                            <DisplayTextOnly value={number} style={style} />
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
NumberFieldDisplay.displayName = "NumberFieldDisplay";
export { NumberFieldDisplay };
